import {CustomerProductCategoryRestDto, MultilingualFieldRestDto} from "@/api/pharma-cpc-product-category-mgmt/models";
import {
    MultilingualFieldRestDtoModel
} from "@/models/api/pharma-cpc-product-category-mgmt/MultilingualFieldRestDtoModel";

export class CustomerProductCategoryRestDtoModel implements CustomerProductCategoryRestDto {

    code: string;
    name: MultilingualFieldRestDto;
    dp_managed_parent_category_code?: string|null;
    parent_code?: string|null;
    sort_weight: number;

    constructor() {
        this.code = '';
        this.name = MultilingualFieldRestDtoModel.createWithDefaults()
        this.sort_weight = 0;
    }

    public static createWithDefaults(): CustomerProductCategoryRestDtoModel {
        return new this();
    }
}
